import axios from 'axios'
import qs from 'qs'
import router from '../router'



axios.defaults.baseURL = localStorage.getItem('X-Api') + '/api'; //  请求服务器具体的地址
axios.defaults.imgURL = localStorage.getItem('X-Api'); //  请求服务器具体的地址

// 请求拦截器
axios.interceptors.request.use(config => {
    const token = localStorage.getItem('X-Token')
    if (token) {
        config.headers['X-Token'] = token
    }
    config.data = qs.stringify(config.data);
    return config
}, error => {
    return Promise.reject(error)
})


// 响应拦截器
axios.interceptors.response.use(res => {
    //登录状态失效
    if (res.data.message == '賬號異地登入' || res.data.message == '登入超時' || res.data.message == '用戶未登入') {
        router.push({
            name: 'Error',
        });
        localStorage.removeItem('X-Token')
    }
    return res
}, error => {
    return Promise.reject(error)
})




export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js